<template>
  <nav :style="{ backgroundColor: navBackgroundColor }">
    <div class="header">
      <img src="./assets/img/logo.png">
      <div>
        <template v-for="nav in navs">
          <router-link :to="nav.path">{{ nav.name }}</router-link>
        </template>
      </div>
    </div>
  </nav>
  <router-view />
</template>
<script setup lang="ts">
import { useStore } from 'vuex';
import { ref, onMounted, onUnmounted } from 'vue'
// 获取 store 实例
const store = useStore();
// 导航栏数据
const navs = ref([
  { name: '首页', path: '/' },
  { name: '产品服务', path: '/product' },
  { name: '数据服务解决方案', path: '/dataSolutions' },
  { name: '互联金融服务解决方案', path: '/financialSolutions' },
  { name: '关于我们', path: '/about' }
])
// 轮播图高度
let bannerHeight = store.state.bannerHeight
// 导航栏背景色
const navBackgroundColor = ref('rgb(0 0 0 / 0%)')
// 监听滚动事件
const handleScroll = () => {
  if (window.scrollY >= bannerHeight) {
    navBackgroundColor.value = 'rgb(0 0 0 / 40%)'; // 根据需要改变颜色
  } else {
    navBackgroundColor.value = 'rgb(0 0 0 / 0%)'; // 根据需要改变颜色
  }
}
// 监听 bannerHeight 的变化
store.subscribe((mutation, state) => {
  console.log(111111111111111111111111111)
  if (mutation.type === 'setbannerHeight') {
    bannerHeight = state.bannerHeight;
  }else if (mutation.type ==='setnavBgColor') {
    navBackgroundColor.value = state.navBgColor;
  }
});
onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

</script>
<style lang="less" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  min-width: 1200px;
}

nav {
  min-width: 1200px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999999;
  background: rgb(0 0 0 / 0%);
  transition: background-color 1s ease;
  /* 平滑过渡效果 */

  .header {

    z-index: 999999;
    height: 110px;
    padding: 0 8.3%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
      height: 44px;
      width: 131px;
    }

    a {
      // font-weight: bold;
      color: #fff;
      margin-left: 45px;
      text-decoration: none;
      padding-bottom: 12px;
      font-size: 20px;

      &.router-link-exact-active {
        // color: #42b983;
        border-bottom: 2px solid #EA2709;
      }
    }
  }

}
</style>
